<!-- SKD Row -->
<div
  class="flight-row skd-row"
  [class.opacity-5]="
    enhanced &&
    hssBuilderService.isFaded(leg, 'skd') &&
    leg.isCancelled.text === 'False'
  "
  [class.e-cxld]="enhanced && leg.isCancelled.text === 'True'"
>
  <span [class.e-skd]="enhanced && leg.isCancelled.text === 'False'">SKD </span>
  <!-- Day -->
  <span [class.e-day]="enhanced && leg.isCancelled.text === 'False'">{{
    hssBuilderService.getDay(leg, "SKD").padEnd(3, " ")
  }}</span>
  <!-- Equip -->
  <span
    [class.e-eq]="enhanced && leg.isCancelled.text === 'False'"
    [class]="
      hssBuilderService.getChangedClass(leg.schedEquipCode.didChange, index)
    "
    >{{
      (leg.schedEquipCode.text || leg.actualEquipCode.text) === ""
        ? "XX "
        : leg.schedEquipCode.text.padEnd(3, " ")
    }}</span
  >
  <!-- Flt Num -->
  @if (leg.fltNum.text !== "0000") {
    <span
      [class.e-flt-num]="enhanced && leg.isCancelled.text === 'False'"
      [class]="hssBuilderService.getChangedClass(leg.fltNum.didChange, index)"
      >{{ hssBuilderService.toInt(leg.fltNum.text).padStart(4, " ") }}</span
    >
  } @else {
    <span>{{ " ".padStart(4, " ") }}</span>
  }
  <!-- Dep Sta -->
  <span
    [class.e-dep-sta]="enhanced && leg.isCancelled.text === 'False'"
    [class]="hssBuilderService.getChangedClass(leg.depStation.didChange, index)"
  >
    {{ leg.depStation.text.padEnd(4, " ") }}</span
  >
  <!-- Dep Time -->
  <span
    [class.e-dep-time]="enhanced && leg.isCancelled.text === 'False'"
    [class]="
      hssBuilderService.getChangedClass(leg.depTimeSchedLocal.didChange, index)
    "
    >{{ leg.depTimeSchedLocal.text | hssTime }}
  </span>
  <!-- Dep Meal -->
  <span
    [class.e-meal]="enhanced && leg.isCancelled.text === 'False'"
    [class]="hssBuilderService.getChangedClass(leg.meal.didChange, index)"
    >{{ leg.meal.text.padEnd(2, " ") }}</span
  >
  <!-- Arr Sta -->
  <span
    [class.e-arr-sta]="enhanced && leg.isCancelled.text === 'False'"
    [class]="hssBuilderService.getChangedClass(leg.arrStation.didChange, index)"
    >{{ leg.arrStation.text.padEnd(4, " ") }}</span
  >
  <!-- Arr Time -->
  @if (leg.isGroundInterrupt.text === "True") {
    <span
      [class.e-arr-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(
          leg.isGroundInterrupt.didChange,
          index
        )
      "
      >****
    </span>
  } @else {
    <span
      [class.e-arr-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(
          leg.arrTimeSchedLocal.didChange,
          index
        )
      "
      >{{ leg.arrTimeSchedLocal.text | hssTime }}
    </span>
  }
  <!-- Add Code -->
  <span
    [class.e-ac]="enhanced && leg.isCancelled.text === 'False'"
    [class]="hssBuilderService.getChangedClass(leg.addCode.didChange, index)"
    >{{ leg.addCode.text.padEnd(2, " ") }}</span
  >
  <!-- Flt Time -->
  <span
    class="text-right"
    [class.e-flt-time]="
      enhanced &&
      leg.isCancelled.text === 'False' &&
      leg.isDhOrSurface.text === 'False'
    "
    [class.e-dh]="
      enhanced &&
      leg.isCancelled.text === 'False' &&
      leg.isDhOrSurface.text === 'True'
    "
    [class]="
      hssBuilderService.getChangedClass(
        leg.depTimeSched.didChange || leg.arrTimeSched.didChange,
        index
      )
    "
    >{{ hssBuilderService.getFlightTimeSched(leg).padStart(7, " ") }}</span
  >
  <!-- NSHW -->
  @if (leg.isDhNoShow.text === "True") {
    <span
      [class.e-gtr-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(leg.isDhNoShow.didChange, index)
      "
      >{{ " NSHW" }}
    </span>
  } @else {
    <span>{{ " ".padStart(5, " ") }}</span>
  }
  <!-- Gnd Time -->
  <span
    [class.e-gnd-time]="enhanced && leg.isCancelled.text === 'False'"
    [class]="
      hssBuilderService.getChangedClass(leg.groundTimeSched.didChange, index)
    "
    >{{ (leg.groundTimeSched.text | hssDuration).padStart(5, " ") }}</span
  >
  <!-- Seat Actual -->
  <span
    [class]="hssBuilderService.getChangedClass(leg.seatActual.didChange, index)"
    >{{ hssBuilderService.getSeatActual(leg, hss).padStart(8, " ") }}</span
  >
  <!-- ACT -->
  <span
    [class]="
      hssBuilderService.getChangedClass(leg.removalCode.didChange, index)
    "
    >{{ leg.removalCode.text.padStart(3, " ") }}</span
  >
</div>
